var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    d: "M.873,10.868a.938.938,0,0,1-.559-.18A.719.719,0,0,1,.2,9.6l3.91-4.17L.343,1.263A.72.72,0,0,1,.476.171.951.951,0,0,1,1.7.289L5.922,4.947a.711.711,0,0,1-.01.984L1.545,10.589a.921.921,0,0,1-.672.279",
    transform: "translate(0 0)",
    fill: "#727272"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(-1372 -227)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(1372 227)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(1383.798 235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color-2",
    "data-name": "Color",
    d: "M.873,10.868a.938.938,0,0,1-.559-.18A.719.719,0,0,1,.2,9.6l3.91-4.17L.343,1.263A.72.72,0,0,1,.476.171.951.951,0,0,1,1.7.289L5.922,4.947a.711.711,0,0,1-.01.984L1.545,10.589a.921.921,0,0,1-.672.279",
    transform: "translate(0 0)",
    fill: "#727272"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyRightCircle);
export default __webpack_public_path__ + "static/media/grey-right-circle.102a72d7f87a24bba2eac30e5b6020b2.svg";
export { ForwardRef as ReactComponent };